import React, { useRef, useEffect } from 'react'
import Typed from 'typed.js'
import BadgeSmall from '../components/BadgeSmall'

const Portfolio = () => {
  const el = useRef(null)
  const typed = useRef(null)

  useEffect(() => {
    const options = {
      strings: [
        'I am a <strong>Software Engineer</strong>',
        'I am a <strong>UI/UX Designer</strong>',
        'I am a <strong>Data Scientist</strong>',
        'I am a <strong>Frontend Engineer</strong>',
        'I am a <strong>Backend Engineer</strong>',
        'I am a <strong>Web Developer</strong>',
        'I am a <strong>Mobile Developer</strong>',
        'I am a <strong>Android Developer</strong>',
        'I am a <strong>AI Developer</strong>',
        'I am a <strong>ML/DL Developer</strong>',
        'I am a <strong>Programmer</strong>'
      ],
      typeSpeed: 50,
      backSpeed: 20,
      loop: true,
      loopCount: Infinity
    }

    // elRef refers to the <span> rendered below
    typed.current = new Typed(el.current, options)

    return () => {
      // Make sure to destroy Typed instance during cleanup
      // to prevent memory leaks
      typed.current.destroy()
    }
  }, [])

  return (
    <main className='min-h-screen p-4 md:p-8 md:pt-16'>
      <div class='px-4 pt-8 pb-16 md:py-10 sm:px-6 lg:px-8'>
        <div class='grid grid-cols-1 gap-y-8 lg:grid-cols-4 lg:items-start lg:justify-items-center'>
          {/* first column */}
          <div className='flex flex-col space-y-2 items-center lg:px-10 lg:border-r-4 lg:border-gray-600'>
            <img
              src='img/photo-profile.jpg'
              alt='profile-img'
              className='rounded-full w-32'
            />
            <h1 class='text-xl font-bold'>Aulia Sabri</h1>
            <div className='flex flex-row'>
              <p className='text-gray-600/80 font-bold [&_strong]:text-yellow-200 [&_strong]:bg-gray-800 [&_strong]:px-2' ref={el} />
            </div>
            <br />
            <div className='flex space-x-4 justify-center items-center lg:justify-start'>
              <a
                href='https://github.com/Aulia-S'
                target='_blank'
                rel='noreferrer'
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  className='w-6 fill-gray-400 hover:fill-gray-500'
                  viewBox='0 0 496 512'
                >
                  <path d='M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z' />
                </svg>
              </a>

              <a
                href='https://www.linkedin.com/in/aulia-sabri-a339711a3'
                target='_blank'
                rel='noreferrer'
              >
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  viewBox='0 0 448 512'
                  className='w-6 fill-gray-400 hover:fill-gray-500'
                >
                  <path d='M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z' />
                </svg>
              </a>

              <a class='group relative inline-block focus:outline-none focus:ring' href='mailto:auliasabri43@gmail.com'>
                <span class='absolute inset-0 translate-x-1.5 translate-y-1.5 bg-yellow-200 transition-transform group-hover:translate-y-0 group-hover:translate-x-0' />
                <span class='flex relative border-2 border-current px-2 py-1.5 text-sm font-bold uppercase tracking-widest text-black group-active:text-opacity-75'>
                  <span className='text-xs'>Send a Message</span>

                  <svg
                    class='ml-3 h-5 w-5'
                    xmlns='http://www.w3.org/2000/svg'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                  >
                    <path
                      stroke-linecap='round'
                      stroke-linejoin='round'
                      stroke-width='2'
                      d='M17 8l4 4m0 0l-4 4m4-4H3'
                    />
                  </svg>
                </span>
              </a>
            </div>
            <br />
            <div className='flex justify-center'>
              <div className='flex justify-center flex-wrap gap-3'>
                <BadgeSmall name='HTML' />
                <BadgeSmall name='CSS' />
                <BadgeSmall name='Bootstrap' />
                <BadgeSmall name='TailwindCSS' />
                <BadgeSmall name='Javascript' language />
                <BadgeSmall name='React.js' />
                <BadgeSmall name='Next.js' />
                <BadgeSmall name='Node.js' />
                <BadgeSmall name='Express.js' />
                <BadgeSmall name='React Native' />
                <BadgeSmall name='Electron.js' />
                <BadgeSmall name='MongoDB' />
                <BadgeSmall name='Python' language />
                <BadgeSmall name='TensorFlow' />
                <BadgeSmall name='Keras' />
              </div>
            </div>
          </div>
          {/* second column */}
          <div class='col-span-2 mx-auto max-w-lg text-center lg:mx-0 lg:text-left lg:px-10'>
            <h2 class='text-3xl font-bold mb-2'>About Me</h2>

            <p class='text-gray-600 mb-2'>
              A versatile Javascript. Graduated from UIN Ar-Raniry Banda Aceh
              Majoring in Information Technology and interest in Mobile and Web
              System. Have experience in programming field since 2018. Proficiency
              in used javascript as a tool to build modern and cross-platform
              app to increase user experience. Besides that i have some
              experience in data science especially deep learning with python.
            </p>

            <img src='img/illus.png' alt='illustration' />
          </div>
          {/* third column */}
          <div class='mx-auto max-w-lg lg:mx-0 lg:px-10'>
            <h2 class='text-3xl font-bold mb-4 text-center'>Experience</h2>

            <ol class='relative text-gray-500 border-l border-gray-200 dark:border-gray-700 dark:text-gray-400'>
              <li class='mb-5 ml-6'>
                <span class='absolute flex items-center justify-center w-8 h-8 bg-yellow-200 rounded-full -left-4 ring-2 ring-gray-900'>
                  <svg className='w-4' fill='bg-gray-200' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                    <path clipRule='evenodd' fillRule='evenodd' d='M1 2.75A.75.75 0 011.75 2h10.5a.75.75 0 010 1.5H12v13.75a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 010-1.5H2v-13h-.25A.75.75 0 011 2.75zM4 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM4.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM8 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM8.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM14.25 6a.75.75 0 00-.75.75V17a1 1 0 001 1h3.75a.75.75 0 000-1.5H18v-9h.25a.75.75 0 000-1.5h-4zm.5 3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z' />
                  </svg>
                </span>
                <h3 class='font-medium leading-tight text-gray-600'>Fullstack Developer</h3>
                <ul class='text-sm text-gray-600'>
                  <li>PTIPD UIN Ar-Raniry · Internship</li>
                  <li>Sep 2021 - Dec 2021</li>
                  <li>Banda Aceh, Aceh, Indonesia</li>
                </ul>
              </li>
              <li class='mb-5 ml-6'>
                <span class='absolute flex items-center justify-center w-8 h-8 bg-yellow-200 rounded-full -left-4 ring-2 ring-gray-900'>
                  <svg className='w-4' fill='bg-gray-200' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                    <path clipRule='evenodd' fillRule='evenodd' d='M1 2.75A.75.75 0 011.75 2h10.5a.75.75 0 010 1.5H12v13.75a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 010-1.5H2v-13h-.25A.75.75 0 011 2.75zM4 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM4.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM8 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM8.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM14.25 6a.75.75 0 00-.75.75V17a1 1 0 001 1h3.75a.75.75 0 000-1.5H18v-9h.25a.75.75 0 000-1.5h-4zm.5 3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z' />
                  </svg>
                </span>
                <h3 class='font-medium leading-tight text-gray-600'>Frontend Developer</h3>
                <ul class='text-sm text-gray-600'>
                  <li>Assessed · Contract</li>
                  <li>Jan 2022 - Jun 2022</li>
                  <li>Yogyakarta, Indonesia</li>
                </ul>
              </li>
              <li class='mb-5 ml-6'>
                <span class='absolute flex items-center justify-center w-8 h-8 bg-yellow-200 rounded-full -left-4 ring-2 ring-gray-900'>
                  <svg className='w-4' fill='bg-gray-200' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                    <path clipRule='evenodd' fillRule='evenodd' d='M1 2.75A.75.75 0 011.75 2h10.5a.75.75 0 010 1.5H12v13.75a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 010-1.5H2v-13h-.25A.75.75 0 011 2.75zM4 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM4.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM8 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM8.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM14.25 6a.75.75 0 00-.75.75V17a1 1 0 001 1h3.75a.75.75 0 000-1.5H18v-9h.25a.75.75 0 000-1.5h-4zm.5 3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z' />
                  </svg>
                </span>
                <h3 class='font-medium leading-tight text-gray-600'>Software Engineer | Data Scientist | UI/UX Designer</h3>
                <ul class='text-sm text-gray-600'>
                  <li>Freelance</li>
                  <li>Sep 2022 - Present</li>
                  <li>Aceh, Indonesia</li>
                </ul>
              </li>
              <li class='mb-5 ml-6'>
                <span class='absolute flex items-center justify-center w-8 h-8 bg-yellow-200 rounded-full -left-4 ring-2 ring-gray-900'>
                  <svg className='w-4' fill='bg-gray-200' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' aria-hidden='true'>
                    <path clipRule='evenodd' fillRule='evenodd' d='M1 2.75A.75.75 0 011.75 2h10.5a.75.75 0 010 1.5H12v13.75a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75v-2.5a.75.75 0 00-.75-.75h-2.5a.75.75 0 00-.75.75v2.5a.75.75 0 01-.75.75h-2.5a.75.75 0 010-1.5H2v-13h-.25A.75.75 0 011 2.75zM4 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM4.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM8 5.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zM8.5 9a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1zM14.25 6a.75.75 0 00-.75.75V17a1 1 0 001 1h3.75a.75.75 0 000-1.5H18v-9h.25a.75.75 0 000-1.5h-4zm.5 3.5a.5.5 0 01.5-.5h1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-1a.5.5 0 01-.5-.5v-1zm.5 3.5a.5.5 0 00-.5.5v1a.5.5 0 00.5.5h1a.5.5 0 00.5-.5v-1a.5.5 0 00-.5-.5h-1z' />
                  </svg>
                </span>
                <h3 class='font-medium leading-tight text-gray-600'>Frontend Developer | Web Developer</h3>
                <ul class='text-sm text-gray-600'>
                  <li>Kerjoo · Contract</li>
                  <li>Oct 2022 - Present</li>
                  <li>Yogyakarta, Indonesia</li>
                </ul>
              </li>
            </ol>

          </div>
        </div>
      </div>
      <footer>
        <p className='text-sm text-center pb-2'>
          &copy; Aulia Sabri {new Date().getFullYear()}
        </p>
      </footer>
    </main>
  )
}

export default Portfolio
